import React, { useEffect } from 'react';

import './Help.scss';
import style from './style.module.scss';
import { useSearchParams } from 'react-router-dom';

const UpdateAppInfo = () => {
  const [searchParams] = useSearchParams();
  const newVersion = searchParams.get('NewVersion') || false;

  const updateComesButCancelIt =
    localStorage.getItem('updateComesButCancelIt') === 'true' ? true : false;

  useEffect(() => {
    const appBar = document.getElementById('appBar');
    const helpContainer = document.getElementById('helpContainer');
    if (appBar) {
      appBar.classList.add('hideAppBar');
      helpContainer.classList.add('pageHeightOnRemoveAppBar');
    }
    return () => {
      appBar.classList.remove('hideAppBar');
      helpContainer.classList.remove('pageHeightOnRemoveAppBar');
    };
  }, []);

  // const currentVersion = localStorage.getItem('applicationVersion') || '';

  return (
    <div>
      <div className={style.infoAboutVersion}>
        {newVersion || !updateComesButCancelIt ? (
          <>
            <p>
              You’re running the latest version: <span>1.4.25.1</span>
            </p>
          </>
        ) : (
          <>
            <p>
              You’re running the older version: <span>1.4.23.1</span>
            </p>
            <p
              style={{
                marginTop: '8px'
              }}
            >
              Refresh your data and follow the prompts to update the application.
            </p>
          </>
        )}
      </div>
      {/* section 1 */}
      <div className="whats-oplii-mobile" style={{ maxWidth: '768px', width: '100%' }}>
        <div className="whats-oplii-mobile--title">Version 1.4.25.1</div>
        <div className={style.yearAndMonth}>March 2025</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fixes</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This is a minor release that addresses bugs to do with inspection and work order
            completion dates.
          </div>
        </div>
      </div>

      {/* section 2 */}
      <div className="whats-oplii-mobile" style={{ maxWidth: '768px', width: '100%' }}>
        <div className="whats-oplii-mobile--title">Version 1.4.23.0</div>
        <div className={style.yearAndMonth}>DECEMBER 2024</div>
        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Main feature: A new bundler</div>
          <div className="whats-oplii-mobile--description">
            OK. It’s not the most exciting, outwardly obvious update—but, it does mean big things
            for Oplii Mobile. We’ve changed the app from the bottom up to use a more modern storage
            method that will reduce the incidence of unwanted restarts, grey screens and update
            issues. So, while this one doesn’t sound fun, it is a much-needed fundamental change
            that will result in a smoother mobile experience for everyone.
          </div>

          <div className="whats-oplii-mobile--title">The smaller stuff:</div>

          <ul className="leastClass">
            <li>
              Some visual and functional changes to filters that make it easier to see and reset
              applied filters, save and edit bookmarks,
            </li>
            <li>
              The page you’re looking at now (coupled with the banner that shows you’ve updated the
              app) is brand new,
            </li>

            <li>Changes to ‘Due Date’ and ‘Scheduled Date’ filters to include overdue work,</li>

            <li>Allowing map-view bookmarks to reopen in map view instead of list view,</li>

            <li>And, finally, a number of bugs were fixed, of course.</li>
          </ul>
        </div>
      </div>

      {/* section 3 */}
      <div className="whats-oplii-mobile" style={{ maxWidth: '768px', width: '100%' }}>
        <div className="whats-oplii-mobile--title">Version 1.4.22.0</div>
        <div className={style.yearAndMonth}>November 2024</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Main feature: Auto-save!</div>
          <div className="whats-oplii-mobile--description">
            We’ve implemented an auto-save feature that saves your tasks as you work on them. That
            way, if something happens and Oplii Mobile crashes or is closed by accident, the task
            you were working on will be available in the ‘In Progress’ tab in your task listings.
          </div>

          <div className="whats-oplii-mobile--title"> The smaller stuff:</div>

          <ul className="leastClass">
            <li>
              When creating a new task, you’ll now see the task menu in the upper right corner,
              which gives you an easier way to save and close it (vs. hitting Back or Cancel),
            </li>
            <li>
              On Home, At-a-glance bookmarks (Home) are now presented vertically to make them easier
              to peruse,
            </li>

            <li>
              The Pin to ‘At a glance’ on home option when creating a new filter is now checked by
              default,
            </li>

            <li>A count of downloaded records are now shown the ‘Data refresh complete’ modal,</li>

            <li>On Home, a new Map button provides a shortcut to the sites list in map view,</li>

            <li>More information is shown when you open assigned checks,</li>

            <li>And, finally, a number of bugs were fixed, of course.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UpdateAppInfo;
